/**
 * 测试环境语音网关：wss://tbig-model-debug.gooki.com/ws
 */
module.exports = {
  env: 'test',
  scheme: 'wss',
  host: 'tbig-model-debug.gooki.com',
  path: '/ws',
  proxyPath: '/voice-ws',
  apiKey: 'sk-f3ff39b49d9c0d7a0a2e992132ae5b326b6f1f7b357f2ab57abec25e213083c1',
  /** 调试时固定传 0 */
  debugScriptReleaseId: '0',
  inputSampleRate: 8000,
}
